/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('campaignActionMenu', {
    bindings: {
      project: '<',
      campaign: '<',
    },
    controller: campaignActionMenuController,
    templateUrl: '/templates/zenclerk_s/directives/campaign/action_menu/campaign_action_menu.html',
  });

campaignActionMenuController.$inject = ['$state', '$filter', '$translate', '$uibModal', 'Campaign', 'Devise', 'campaignStatuses', 'ZcsCampaign'];
function campaignActionMenuController($state, $filter, $translate, $uibModal, Campaign, Devise, campaignStatuses, ZcsCampaign) {
  const vm = this;
  let state;

  vm.$onInit = () => {
    setConfirmToggleCampaignState();
    if(vm.campaign.incentives[0] && vm.campaign.incentives[0].is_integrated_with_makeshop) {
      vm.confirmRemoveCampaign = $translate.instant('directives.campaign.actionMenu.confirmRemoveCampaignMessage');
    }

    vm.isMenuActive = false;
    vm.isAllowedLiteTemplate = isAllowedLiteTemplate;
    vm.openMailMagUrlModal = openMailMagUrlModal;
    vm.openPreviewLinkModal = openPreviewLinkModal;
    vm.copyCampaign = copyCampaign;
    vm.toggleCampaignState = toggleCampaignState;
    vm.removeCampaign = removeCampaign;
    vm.canShowReportButton = canShowReportButton;
    vm.isActiveProject = vm.project.terminated_at === null || moment(vm.project.terminated_at) > new Date();
    vm.isOemProject = vm.project.is_oem;
    vm.isMaster = Devise.isMaster();
  };

  // mail mag url modal
  function openMailMagUrlModal() {
    ZcsCampaign.openMailMagUrlModal(vm.campaign, vm.project);
    vm.isMenuActive = false;
  }

  // preview link modal
  function openPreviewLinkModal() {
    $uibModal.open({
      templateUrl: '/templates/zenclerk_s/sites/campaigns/preview_link_modal.html',
      openedClass: 'preview-link-modal',
      size: 'lg',
      controllerAs: '$ctrl',
      controller: 'ZcsPreviewLinkModalController',
      resolve: {
        campaign: vm.campaign,
        project: vm.project
      }
    });
    vm.isMenuActive = false;
  }

  // duplicate campaign
  function copyCampaign(campaign) {
    const campaignObject = _.merge({}, campaign);

    return Campaign.copy({projectId: vm.project.id, campaignId: campaignObject.id}, campaignObject)
      .then(res => $state.go('zenclerkS.project.campaigns.draft', {apikey: vm.project.apikey}, { reload: true }));
  }

  // toggle campaign state
  function toggleCampaignState() {
    vm.isMenuActive = false;
    if(vm.campaign.status === 'activated') {
      state = 'blocked';
    }
    if(vm.campaign.status === 'blocked') {
      state = 'activated';
    }
    return Campaign.toggleActive({
      projectId: vm.campaign.project_id,
      campaignId: vm.campaign.id,
      state: state === 'activated'
    })
      .then(function(res) {
        if(res.data.success) {
          vm.campaign.status = state;
          let currentStatus = $filter('currentStatus')(vm.campaign);
          vm.campaign.current_status = currentStatus;
          vm.currentStatusText = campaignStatuses[vm.campaign.current_status].text;
          setConfirmToggleCampaignState();
          return true;
        }
      });
  }

  // delete campaign
  function removeCampaign(campaign) {
    const campaignObject = _.merge({}, campaign);
    if(campaignObject.status === 'incomplete') {
      // If it has not ran yet, destroy (note that we also exclude preview because
      // it has been in publish.js and there can be data with that campaign id)
      return Campaign.destroy({projectId: vm.project.id, campaignId: campaignObject.id})
        .then(res => $state.go('zenclerkS.project.campaigns.draft', {apikey: vm.project.apikey}, { reload: true }));
    }

    // Otherwise, make it terminated
    // Note, we need to use "terminate" because just updating status
    // would not set end_at to the moment it was terminated!
    return Campaign.terminate({projectId: vm.project.id, campaignId: campaignObject.id}, campaignObject)
      .then(res => {
        campaign.status = 'terminated';
        $state.go('zenclerkS.project.campaigns.active', {apikey: vm.project.apikey}, { reload: true });
      });
  }

  function isAllowedLiteTemplate() {
    return ZcsCampaign.isAllowedLiteTemplate(vm.campaign, vm.project);
  }

  function canShowReportButton() {
    if($state.current.name === 'zenclerkS.project.campaign.summary') {
      return false;
    }

    if(moment(vm.campaign.start_at).isAfter(moment())) {
      return false;
    }

    if(moment(vm.campaign.end_at).isSameOrBefore(moment(ZcsCampaign.FIST_DATA_DAY))) {
      return false;
    }

    if(vm.campaign.current_status === 'incomplete') {
      return false;
    }

    return true;
  }

  function setConfirmToggleCampaignState() {
    if(vm.campaign.incentives[0] && vm.campaign.incentives[0].is_integrated_with_makeshop) {
      if(vm.campaign.current_status === 'blocked') {
        vm.confirmToggleCampaignState = $translate.instant('directives.campaign.actionMenu.confirmToggleCampaignStateBlocked');
      } else if(vm.campaign.current_status === 'active') {
        vm.confirmToggleCampaignState = $translate.instant('directives.campaign.actionMenu.confirmToggleCampaignStateActive');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/campaign/action_menu/campaign_action_menu.js